// ngx-mask format: 0* = unlimited digits (including zero)
export const OnlyNumberWithZeroMask: string = '0*';
